(function(){
  var P = GP.productos, IX = GP.ix, esc = GP.esc, clp = GP.fmt, foto = GP.foto, url = GP.url, $ = GP.$;

  function pintar(){
    var L = GP.cmp();
    if (!L.length){
      $('#tabla').innerHTML = '<div class="vacio"><p>Todavía no eliges nada para comparar.</p>'+
        '<a class="btn btn--oro" href="/collections/catalogo">Ver el catálogo</a></div>';
      pintarSugeridos(); return;
    }

    var cols = 'minmax(120px,180px) repeat('+L.length+',1fr)';
    var notasPorProd = L.map(function(p){ return GP.notasDe(p); });
    var comunes = notasPorProd.length > 1
      ? notasPorProd[0].filter(function(n){ return notasPorProd.every(function(l){ return l.indexOf(n)>=0; }); })
      : [];

    var precios = L.map(function(p){ return p.p; });
    var porMl = L.map(function(p){ return p.ml ? p.p/p.ml : null; });
    var minPrecio = Math.min.apply(null, precios);
    var mlVal = porMl.filter(function(x){return x!==null;});
    var minMl = mlVal.length ? Math.min.apply(null, mlVal) : null;
    var maxNotas = Math.max.apply(null, notasPorProd.map(function(l){return l.length;}));

    function fila(rot, celdas){
      return '<div class="cmp__fila" style="grid-template-columns:'+cols+'">'+
        '<div class="cmp__rot">'+rot+'</div>'+
        celdas.map(function(c,k){ return '<div class="cmp__c" data-nom="'+esc(L[k].n)+'">'+c+'</div>'; }).join('')+
      '</div>';
    }

    $('#tabla').innerHTML = '<div class="cmp">'+
      '<div class="cmp__fila" style="grid-template-columns:'+cols+'">'+
        '<div class="cmp__rot"></div>'+
        L.map(function(p){
          return '<div class="cmp__c cmp__cab">'+
            '<a href="'+url(p)+'">'+(foto(p)?'<img src="'+foto(p)+'" alt="'+esc(p.n)+'">':'')+
            '<p class="m">'+esc(p.b||'')+'</p><p class="n">'+esc(p.n)+'</p></a>'+
            '<p class="p">'+clp(p.p)+'</p>'+
            (p.p===minPrecio && L.length>1 ? '<span class="cmp__mejor">El más barato</span>' : '')+
            '<button class="btn btn--linea btn--sm btn--bloque" style="margin-top:10px" type="button" data-add="'+p.i+'">Agregar</button>'+
            '<button class="cmp__quitar" type="button" data-cmp="'+p.i+'">Quitar del comparador</button>'+
          '</div>';
        }).join('')+
      '</div>'+
      fila('Precio por ml', L.map(function(p,k){
        var v = porMl[k];
        return v===null ? '—' : '<b style="font-family:var(--serif);font-size:17px">'+clp(Math.round(v))+'</b>'+
          (minMl!==null && Math.round(v)===Math.round(minMl) && L.length>1 ? ' <span class="cmp__mejor">Mejor</span>' : '');
      }))+
      fila('Tamaño', L.map(function(p){ return p.ml ? p.ml+' ml' : '—'; }))+
      fila('Concentración', L.map(function(p){ return esc(p.t||'—'); }))+
      fila('Para quién', L.map(function(p){ return esc(p.g||'—'); }))+
      fila('Familia', L.map(function(p){ return esc((p.f||[]).join(', ')||'—'); }))+
      fila('Notas declaradas', L.map(function(p,k){
        var n = notasPorProd[k];
        return n.length ? '<div class="notas">'+n.map(function(x){
          return '<span class="nota'+(comunes.indexOf(x)>=0?' nota--comun':'')+'">'+esc(x)+'</span>';
        }).join('')+'</div>'+
        '<p style="font-size:11.5px;color:var(--tinta-3);margin:8px 0 0">'+n.length+' de '+maxNotas+'</p>' : '—';
      }))+
      fila('Sigue a', L.map(function(p){
        var e = GP.equiv(p);
        if (e) return esc(p.ins)+'<br><span style="font-size:11.5px;color:var(--oro)">El ml cuesta '+e.pct+'% menos que el original</span>';
        return p.ins ? esc(p.ins) : '—';
      }))+
      fila('Disponibilidad', L.map(function(p){
        return p.st && p.st<=5 ? '<span style="color:var(--alerta)">Quedan '+p.st+'</span>' : 'Disponible';
      }))+
    '</div>'+
    (L.length>1 ? '<p style="font-size:13px;color:var(--tinta-3);margin:16px 0 0">'+
      (comunes.length
        ? '<b style="color:var(--oro)">'+comunes.length+' notas en común</b> entre los '+L.length+': '+esc(comunes.join(', '))+'.'
        : 'No comparten ninguna nota declarada: son perfumes bien distintos.')+'</p>' : '');

    pintarSugeridos();
  }

  function pintarSugeridos(){
    var L = GP.cmp();
    if (!L.length){ $('#sugeridos').innerHTML=''; return; }
    var yaId = L.map(function(p){return p.i;});
    var cand = {};
    L.forEach(function(p){
      (GP.sim[p.i]||[]).forEach(function(s){
        if (yaId.indexOf(s.id)<0) cand[s.id] = Math.max(cand[s.id]||0, s.comunes);
      });
    });
    var l = Object.keys(cand).map(function(i){ return IX[+i]; })
      .filter(function(p){ return p && p.img; })
      .sort(function(a,b){ return cand[b.i]-cand[a.i]; }).slice(0,4);
    if (!l.length){ $('#sugeridos').innerHTML=''; return; }
    $('#sugeridos').innerHTML = '<section class="sec"><div class="cabsec"><div>'+
      '<p class="eyebrow">Para seguir comparando</p>'+
      '<h2 class="display" style="font-size:1.9rem">Comparten notas con lo que ya elegiste</h2></div></div>'+
      '<div class="grid">'+GP.grid(l)+'</div></section>';
  }

  /* buscador del picker */
  function pintarPicker(q){
    var l = q && q.length>1 ? GP.buscar(q, 12)
          : P.filter(function(p){return p.img && p.fo==='perfume' && p.ins;}).slice(0,12);
    var ya = GP.cmp().map(function(p){return p.i;});
    $('#pres').innerHTML = l.length ? l.map(function(p){
      var on = ya.indexOf(p.i)>=0;
      return '<button class="picker__it" type="button" data-cmp="'+p.i+'">'+
        (foto(p)?'<img src="'+foto(p)+'" alt="">':'<span></span>')+
        '<span><strong>'+esc(p.n)+'</strong><span>'+esc(p.b||GP.meta(p))+'</span></span>'+
        '<b>'+(on?'✓ en el comparador':clp(p.p))+'</b></button>';
    }).join('') : '<p style="color:var(--tinta-3);font-size:13.5px;padding:12px 0;margin:0">Sin resultados. Prueba con la marca o una nota.</p>';
  }
  var t;
  $('#pq').addEventListener('input', function(){
    var v = this.value;
    clearTimeout(t); t = setTimeout(function(){ pintarPicker(v); }, 120);
  });

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-cmp]')) setTimeout(function(){ pintar(); pintarPicker($('#pq').value); }, 30);
  });

  GP.montar('');
  pintar();
  pintarPicker('');
})();